<template>
    <div class="container-fluid">
      <div class="row">
        <sidebar></sidebar>
        <nav-header></nav-header>
  
        <!-- MAIN CONTENT start -->
        <main role="main" class="col-12 col-sm-9 col-md-10 ml-sm-auto col-lg-10" >
        
  
          <section class="px-sm-0 mx-sm-0 px-lg-5 mx-lg-5  mt-0 mt-md-5">
            <div  class="container">
              <div class="row my-5">
                <div class="col-sm-12">
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-4 mb-4" v-for="(data,i) of components" :key="i"> <h4 class="text-center">{{ data.component }}</h4> 
                            <div v-for="(rateType,j) of data.subject_calendar_default" :key="j"> <h6 class="text-center">{{ helpers.getLocalizedField(rateType,'RatesType') }} - {{ rateType.point }}</h6></div>
                            <div class="text-danger text-right">.zip</div>
                        <input type="file" :key="data.subject_master_componentID" class="form-control" @change="uploadFile($event,data.subject_master_componentID)"/>
                                <div v-if="uploadedFiles[data.subject_master_componentID]" class="mt-3">
                                <div>
                                    <a class="d-block" href="#" @click="downloadFile(file)" :key="k" v-for="(file,k) of uploadedFiles[data.subject_master_componentID].uploadedFiles">{{ file }}</a> 
                                </div>
                                  <div>
                                    <h4>{{ uploadedFiles[data.subject_master_componentID].comments }}</h4>
                                </div>
                            </div>
                            <div v-else></div>

                        </div>
                    </div>
               
                </div>
              </div>
            </div>
            
    </section>
    </main>
    </div>
    </div>
    </template>


<script>
 import sidebar from '../components/navbar/sidebar';
 
 
  import NavHeader from '../components/navbar/nav-header';

import ScheduleResource from '../api/scheduleResource';
const scheduleResource=new ScheduleResource()
export default{

    components:{ sidebar, NavHeader },
    data(){

        return{
                components:[],
                uploadedFiles:[]


        }


    },
    mounted(){

        scheduleResource.getComponents().then(response=>{

           this.components=response.data
        })


        scheduleResource.getFiles().then(response=>{
            this.uploadedFiles=response.data
        })

    },
    
    
    methods:{

            uploadFile(event,subject_master_componentID){

            
                let formData=new FormData()

                formData.append('file',event.target.files[0])
                formData.append('subject_master_componentID',subject_master_componentID)


                scheduleResource.uploadFiles(formData).then(()=>{
                    location.reload()
                })


            },

            downloadFile(file_name){

                scheduleResource.downloadFile(file_name).then(response=>{

              

                     const url = URL.createObjectURL(response.data);

                            const a = document.createElement("a");
                            a.href = url;
                            a.download = file_name;  
                            document.body.appendChild(a);
                            a.click();

                             
                            document.body.removeChild(a);
                            URL.revokeObjectURL(url);


                })

            }



    }

}

</script>